$(function () {
    let $element = $('[data-plugin="back-to-top"]');

    if ($element.length > 0) {
        $element.on('click', function (e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: 0
            }, 700);
        });

        $(window).scroll(function () {
            // get the scroll position top
            let $container = $('#left-sidebar');
            let $footer = $('footer#footer');

            let footer_start = $footer.offset().top ;

            if ($(document).scrollTop() + window.innerHeight < footer_start + 110) {
                $container.css('position', 'fixed').css('top', 'unset');
            } else if ($container.offset().top + $container.height() >= footer_start) {
                $container.css('position', 'absolute').css('top', (footer_start - $container.outerHeight()) + 'px')
            }
        });
    }
});
